import { render } from "./HeaderNavTwo.vue?vue&type=template&id=c25547a8"
import script from "./HeaderNavTwo.vue?vue&type=script&lang=js"
export * from "./HeaderNavTwo.vue?vue&type=script&lang=js"

import "./HeaderNavTwo.vue?vue&type=style&index=0&id=c25547a8&lang=scss"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__